import {
  Component,
  HostBinding,
  HostListener,
  Input,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import { BehaviorSubject, Observable, timer } from 'rxjs';
import { filter, map, mapTo, startWith, switchMap, tap } from 'rxjs/operators';

@Component({
    selector: 'lib-fab-save',
    templateUrl: './fab-save.component.html',
    styleUrls: ['./fab-save.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FabSaveComponent implements OnInit {
  @Input() isLoading$ = new BehaviorSubject<boolean>(null);
  showIsDoneIcon$: Observable<boolean>;

  @HostBinding('class.isLoading') get isLoading() {
    return this.isLoading$.value;
  }

  constructor() {}

  @HostListener('click', ['$event']) click(event: PointerEvent) {
    console.log('clicked', event);
    if (this.isLoading$.value) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
  }

  ngOnInit(): void {
    this.isLoading$.next(null);
    this.showIsDoneIcon$ = this.isLoading$.pipe(
      filter((status) => status !== null),
      map((isLoading) => !isLoading),

      switchMap((x) =>
        timer(5000).pipe(
          mapTo(false),
          startWith(x),
          tap((x) => console.log(x))
        )
      ),
      startWith(false)
    );
  }
}
